import React from 'react'
import { Container } from 'reactstrap'
import { Title } from '@pga/pga-component-library'
import { isEmpty } from 'ramda'
import DetailBody from './DetailBody'
import DetailCard from './DetailCard'
import { HeaderImage } from './styled'
import { getHeaderImg } from './utils'

export default ({ hit }) => {
  const showHeaderImage = hit.header_image
  return (
    <Container>
      {showHeaderImage && <HeaderImage img={getHeaderImg(hit.header_image)} alt='' />}
      <div className='d-flex'>
        <div className='col-lg-8'>
          <Title size='lg' className='py-4'>{hit.title}</Title>
          <DetailBody hit={hit} />
        </div>
        <div className='col-lg-4'>
          {!isEmpty(hit) ? <DetailCard hit={hit} showHeaderImage={showHeaderImage} /> : null}
        </div>
      </div>
    </Container>
  )
}
